import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import classnames from 'classnames'

import {jsonResponseHandler} from "../../../../utils/FetchHelper"
import { connect } from "react-redux";
import {addPrefix} from "../../../../utils/UriUtil";

@connect(state => ({}), dispatch => ({
    dispatch
}))
class BlogFaviconForm extends Component {

	constructor() {
		super()
		this.state = {
			uploading: false
		}
	}

	@autobind
	handleUpload() {
		const { onChange } = this.props
		const { faviconFile } = this.refs

		if (faviconFile.files.length === 0) {
			return
		}

		let file = faviconFile.files[0]
		if (file.size > 100000) {
			alert("파일 사이즈가 너무 큽니다. 100KB 이하의 파일을 사용해주세요.")
			return
		}

		this.uploadLogo(file).then(url => {
			if (!url) {
				return
			}
			onChange(url)
		})
	}

	@autobind
	uploadLogo(file) {

		const { dispatch } = this.props;
		const { faviconFile } = this.refs
		let formdata = new FormData()
		formdata.append("files[]", file, file.name)

		this.setState({
			uploading: true
		})

		return fetch(addPrefix("/manage/setting/blog/favicon.json"), {
			method: 'post',
			credentials: "include",
			body: formdata
		})
			.then(jsonResponseHandler(dispatch))
			.then(r => r.json())
			.then(data => {
				faviconFile.value = ''
				this.setState({
					uploading: false
				})
				return data.url
			})
			.catch(e => {
				console.error(e)
				alert("이미지를 업로드하지 못했습니다.")
				faviconFile.value = ''
				this.setState({
					uploading: false
				})
			})
	}

	render() {
		const { uploading } = this.state
		const { favicon, onDelete } = this.props

		return (
			<fieldset className="fld_favicon">
				<legend className="screen_out">아이콘 이미지 설정</legend>
				<div className="wrap_thumb icon_thumb">
					{ favicon &&
						<img src={favicon} className="thumb_img" width="32" height="32" alt=""/>
					}

					{ uploading &&
						<span className="ico_blog ico_loading"/>
					}
				</div>
				<strong className="tit_set">파비콘 <span className="info_sub">파일형식 ICO</span></strong>
				<label className="lab_btn">
					<span className="txt_btn">불러오기</span>
					<input ref="faviconFile" type="file" className="btn_g" accept=".ico" onChange={this.handleUpload} />
				</label>
				<label className={classnames("lab_btn", { "lab_off": !favicon })}>
					<span className="txt_btn">삭제</span>
					<input type="button" className="btn_g" value="삭제" onClick={onDelete} disabled={!favicon} />
				</label>
			</fieldset>
		)
	}
}

BlogFaviconForm.propTypes = {
	favicon: PropTypes.string.isRequired,
	onChange: PropTypes.func,
	onDelete: PropTypes.func
}

export default BlogFaviconForm
